import React from 'react'
import PropTypes from 'prop-types'

import { t } from 'src/lib/i18n-react'

import AllTimeStatsWidgetSkeleton from './AllTimeStatsWidgetSkeleton'
import AllTimeStatsWidgetBody from './subcomponents/AllTimeStatsWidgetBody/AllTimeStatsWidgetBody'

const AllTimeStatsWidget = (props) => {
  return (
    <AllTimeStatsWidgetSkeleton
      headerSection={t('All Time Stats')}
      bodySection={<AllTimeStatsWidgetBody {...props} />}
    />
  )
}

AllTimeStatsWidget.propTypes = {
  bodySection: PropTypes.any,
}

export default AllTimeStatsWidget
